import '../styles/FormContact.css';
import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { toast } from 'react-toastify';

const FormContact = () => {

    const SERVICE_KEY= process.env.REACT_APP_SERVICE_KEY;
    const TEMPLATE_KEY= process.env.REACT_APP_TEMPLATE_KEY;
    const PUBLIC_KEY= process.env.REACT_APP_PUBLIC_KEY;

    const initState = {
        fullName: '',
        email: '',
        message: ''
    }

    const errors = {}

    const [formData, setFormData] = useState(initState);

    const { fullName, email, message } = formData;

    const onChange = (e) => {

        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });

    }

    function validate() {

        const validEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{3,4}$/i;

        const validName = /^[a-zA-ZÀ-Ÿ][A-zÀ-ÿ']+\s([A-zÀ-ÿ']\s?)*[a-zA-ZÀ-Ÿ][A-zÀ-ÿ']+$/;

        //validate fullname

        if (!formData.fullName.match(validName)) {
            errors.fullName = toast.error('Digite um nome válido!');
        }

        //validate email

        if (formData.email &&
            (!formData.email.match(validEmail))) {
            errors.email = toast.error('Digite um email válido!');
        }

        //validate message

        if ((formData.message.length < 50)) {
            errors.message = toast.error('Sua mensagem deve ter ao menos 50 caracteres!');
        }

        return errors;

    }

    function sendEmail(e) {

        e.preventDefault();

        const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 3000));

        if (!errors.fullName &&
            !errors.email &&
            !errors.message) {

            document.getElementById('btnSubmit').disabled = true;

            toast.promise(
                resolveAfter3Sec,

                {
                    pending: 'Enviando...',
                }
            )

            emailjs.sendForm(SERVICE_KEY, TEMPLATE_KEY, e.target, PUBLIC_KEY)

                .then((result) => {

                    console.log(result.text);

                    toast.promise(
                        resolveAfter3Sec,
                        {
                            success: 'Mensagem enviada com sucesso!',
                        }
                    )

                    setFormData(initState);

                }, (error) => {

                    console.log(error.text);
                    toast.promise(
                        resolveAfter3Sec,
                        {
                            error: 'Algo deu errado, tente novamente!',
                        }
                    )

                })

        }

    };

    return (

        <section className='contact_container'>

            <div className='box_title'>

                <h2 className='title'>Fale comigo:</h2>

            </div>

            <form onSubmit={sendEmail}>

                <fieldset>

                    <legend>
                        Nome <b>*</b>
                    </legend>

                    <input
                        type="text"
                        name="fullName"
                        placeholder='Lucas Almeida'
                        value={fullName}
                        onChange={onChange}
                        minLength='5'
                        className='fullName'
                    />

                </fieldset>

                <fieldset>

                    <legend>E-mail</legend>

                    <input
                        type="email"
                        name="email"
                        placeholder='lucasalmeida@email.com'
                        value={email}
                        onChange={onChange}
                    />

                </fieldset>

                <fieldset>

                    <legend>
                        Mensagem <b>*</b>
                    </legend>

                    <textarea
                        name="message"
                        placeholder='Como posso te ajudar?'
                        value={message}
                        onChange={onChange}
                        minLength='50'
                        maxLength='500'
                    />

                </fieldset>

                <input
                    type="submit"
                    value="Enviar Mensagem"
                    id='btnSubmit'
                    className='btn_submit'
                    onClick={validate}
                />

            </form>

        </section>

    )

}

export default FormContact;